<style lang="less" scoped>
    .query-title-div{
        width:90px !important;
    }
    .lang-width{
        width:450px !important;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">充电桩列表</div>
            <ZD-list-querys>
                <template slot="inputs">
                    <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">运营商名称</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.dealName" placeholder="请输入内容" clearable></el-input>
                        </div>
                    </div> -->
                    <!-- <div class="list-query-child-div flex">
                        <div class="query-title-div">电站名称</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.stationName" placeholder="请输入内容"></el-input>
                        </div>
                    </div> -->
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">充电桩编号</div>
                        <div class="query-inputs-div flex-1">
                            <!-- <el-select class="full-width" v-model="queryInfo.pileCode" filterable size="small" clearable remote reserve-keyword :remote-method="getPileCodeArr" placeholder="请输入4位或4位以上编号">
                                <el-option v-for="item in pileCodeArr" :key="item.pileCode" :label="item.pileCode" :value="item.pileCode"></el-option>
                            </el-select> -->
                            <el-input size="small" v-model="queryInfo.pileCode" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">充电桩状态</div>
                        <div class="query-inputs-div flex-1">
                            <el-select class="full-width" size="small" v-model="queryInfo.pileStatus" clearable >
                                <el-option label="充电中" value="01"></el-option>
                                <el-option label="离线" value="07"></el-option>
                                <el-option label="待机" value="04"></el-option>
                                <el-option label="故障" value="05"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">充电桩类型</div>
                        <div class="query-inputs-div flex-1">
                            <el-select  class="full-width" size="small" v-model="queryInfo.optType" clearable >
                                <el-option label="私有桩" value="01"></el-option>
                                <el-option label="公共桩" value="02"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">是否报修</div>
                        <div class="query-inputs-div flex-1">
                            <el-select  class="full-width" size="small" v-model="queryInfo.isRepair" clearable >
                                <el-option label="是" value="Y"></el-option>
                                <el-option label="否" value="N"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">用户反馈</div>
                        <div class="query-inputs-div flex-1">
                            <el-select  class="full-width" size="small" v-model="queryInfo.userReply" clearable >
                                <el-option label="有" value="Y"></el-option>
                                <el-option label="无" value="N"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">创建系统时间</div>
                        <div class="query-inputs-div flex-1">
                             <el-date-picker v-model="searchTime" style="width:320px;" type="daterange" size="small" value-format="yyyy-MM-dd 00:00:00" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange"></el-date-picker>
                        </div>
                    </div>
                </template>
                <template  slot="actions">
                    <div class="">
                        <button class="common-bg-button" @click="getListData(pagination, true)">搜 索</button>
                        <button class="common-empty-button" @click="reset()">重 置</button>
                    </div>
                    <div class="">
                        <button class="common-bg-button" @click="toExportList" style="width:80px;margin-top:15px">导出</button>
                    </div>
                </template>
            </ZD-list-querys>
            <div class="page-action-btns flex">
                <!-- <button class="common-bg-button" @click="listDetailFun()">详 情</button> -->
                <button class="common-bg-button" v-if="$S.checkUserMenu('PILE_EDIT')" @click="listEditFun()">编 辑</button>
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {
                    optType: ''
                },
                operates: {
					width: 220,
					fixed: "right",
					list: [
						{
							id: "report",
                            label: "报表",
                            type:"primary",
							show: true,
							disabled: false,
							method: (index, row) => {
                                console.log(row.pileNo)
                                this.$store.commit('setEditId', row.pileEntity.id)
                                this.$store.commit('setPileNo', row.pileNo)
								// this.$router.push({
                                //     name: pageConfig.reportDetailRouter,
                                // });
                                window.open(this.$router.resolve({name: pageConfig.reportDetailRouter}).href,'_blank')
							}
						},
						{
							id: "charge",
                            label: "充电记录",
                            type:"primary",
							show: true,
                            // 按钮权限
                            auth:true,
                            authName:'PILE_CHARGE_RECORD',
							disabled: false,
							method: (index, row) => {
								this.$store.commit('setEditId', row.pileEntity.id)
								// this.$router.push({
								// 	name: pageConfig.chargeDetailRouter
                                // });
                                window.open(this.$router.resolve({name: pageConfig.chargeDetailRouter}).href,'_blank')
							}
                        },
                        {
							id: "repair",
                            label: "维修",
                            type:"primary",
							show: true,
							disabled: false,
							method: (index, row) => {
								this.$store.commit('setRepairObj', row.pileEntity)
								// this.$router.push({
								// 	name: pageConfig.repairListDetail
                                // });
                                window.open(this.$router.resolve({name: pageConfig.repairListDetail}).href,'_blank')
							}
                        },
                        {
							id: "fault",
                            label: "故障记录编辑",
                            type:"primary",
							show: true,
							disabled: false,
                            // 按钮权限
                            auth:true,
                            authName:'PILE_ERROR_RECORD',
							method: (index, row) => {
								this.$store.commit('setEditId', row.pileEntity.id)
								// this.$router.push({
								// 	name: pageConfig.faultDetail
                                // });
                                window.open(this.$router.resolve({name: pageConfig.faultDetail}).href,'_blank')
							}
                        },
					]
                }, // 列操作按钮
                searchTime:[],
                pileCodeArr:[],
            }
        },
        methods: {
            init() {
                if(this.$route.params.stationName){
                    this.queryInfo.stationName = this.$route.params.stationName;
                }
                if(this.$route.query.stationNo){
                    this.queryInfo.stationNo = this.$route.query.stationNo;
                };
                this.getListData(this.pagination,true);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.corpNo = _.$store.state.corpNo;
                _.$H.post(_, _.$A.pile.pile, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            getPileCodeArr(query){
                let _ = this
                if (query.length >= 4) {
                    //this.loading = true;
                    var obj = {
                        sort : '-pileCode',
                        pileCode: query 
                    }
                    _.$H.post(_, _.$A.pile.findPileCodeList,obj).then(res => {
                            _.pileCodeArr = res.data.data
                    })
                } else {
                    this.pileCodeArr = [];
                }
            },
            // 页面新增方法
            listAddFun() {
                this.$S.listAddFun(this, pageConfig.tableEditObj);
            },
            // 页面编辑方法
            // listDetailFun() {
            //     this.$S.listEditFun(this, this.selections, pageConfig.tableDetailObj);
            // },
            listEditFun() {
                let _ = this;
                // this.$S.listEditFun(this, this.selections, pageConfig.tableEditObj);
                this.$store.commit('setEditId', _.selections[0].pileEntity.pileCode);
                // _.$router.push({
                //     name: 'pileDetail'
                // });
                window.open(this.$router.resolve({name: 'pileDetail'}).href,'_blank')
            },
            handleDateChange(val){
                if(val){
                    this.queryInfo.dtFrom = val[0];
                    this.queryInfo.dtTo = val[1];
                }else{
                    delete this.queryInfo.dtFrom;
                    delete this.queryInfo.dtTo;
                }
                
            },
            toExportList(){
                let _ = this;
                // if(_.queryInfo.optType != '02'){
                //     _.$U.error('仅支持公共桩导出');
                //     return;
                // }
                if(_.queryInfo.optType == '' || _.queryInfo.optType == undefined ){
                    _.$U.error('请选择充电桩类型');
                    return;
                }
                _.$U.showLoading(_);
                _.queryInfo.dealNo = _.$store.state.userInfo.dealNo
                _.$H.post(_, _.$A.pile.exportPile, _.queryInfo).then(res => { 0
                    _.$U.saveExcelFile(res.data.data);
                    var downUrl = 'http://ocharge.shzhida.com:6775'  + res.data.data.data
                    window.open(downUrl,'_blank')
                    _.btnUse = true;
                   _.$U.hideLoading(_);
                })
            },
            reset(){
                this.pagination.current = 1;
                delete this.queryInfo.dealName;
                delete this.queryInfo.stationName;
                delete this.queryInfo.stationNo;
                delete this.queryInfo.stationNo;
                delete this.queryInfo.chargeStatus;
                delete this.queryInfo.pileStatus;
                delete this.queryInfo.isRepair;
                delete this.queryInfo.pileCode;
                delete this.queryInfo.optType;
                delete this.queryInfo.dtFrom;
                delete this.queryInfo.dtTo;
                delete this.queryInfo.userReply;
                this.searchTime = [];
                this.getListData(this.pagination);
            },
        },
        mounted() {
            this.init();
            // 操作按钮过滤
            this.operates.list = this.$S.checkListAuthBtn(this.operates.list);
        }
    }
</script>